<template>
  <div class='backWrap' @click='gotoBack'>
    <el-button type="primary" class="backBtn">返回主页<i class="el-icon-s-promotion el-icon--right"></i></el-button>
  </div>
</template>

<script>
export default {
  methods:{
    gotoBack(){
      this.$router.push('/')
    }
  }
}
</script>

<style>
  .backWrap{
    position: absolute;
    right: 20px;
    top:7px;
    z-index: 1000;
    cursor: pointer;
    font-weight: 600
  }
  /* .backBtn{
    font-weight: 600 !important;
    font-family: '楷体';
    font-size: 14px
  } */
</style>